import { gql } from 'graphql-tag'

export const FRAGMENT_AVATAR_USER = gql`
  fragment AvatarUser on user {
    id
    virtual_display_name
    virtual_avatar_url
    virtual_progression_points
  }
`
